import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import styles from './style.module.scss';
import { alertService } from 'shared/ui/components/alert/service';
import { UIButton } from '../button/button';

type AlertContextType = {
  showAlert: (message: ReactNode) => void;
  closeAlert: () => void;
};

const AlertContext = createContext<AlertContextType>({
  showAlert: () => {},
  closeAlert: () => {},
});

export const useAlert = () => useContext(AlertContext);

type AlertProviderProps = {
  children: ReactNode;
};

export const AlertProvider = ({ children }: AlertProviderProps) => {
  const [message, setMessage] = useState<ReactNode>('');
  const [isVisible, setIsVisible] = useState(false);

  const showAlert = (msg: ReactNode) => {
    setMessage(msg);
    setIsVisible(true);
  };

  const handleClose = () => {
    setIsVisible(false);
    setMessage('');
  };

  useEffect(() => {
    alertService.init(showAlert, handleClose);
  }, []);

  return (
    <AlertContext.Provider
      value={{
        showAlert,
        closeAlert: handleClose,
      }}
    >
      {children}
      {isVisible && (
        <div className={styles.overlay}>
          <div className={styles.alert}>
            <div className={styles.message}>{message}</div>
            <UIButton fullwidth onClick={handleClose} className={styles.button}>
              OK
            </UIButton>
          </div>
        </div>
      )}
    </AlertContext.Provider>
  );
};
